import { atom } from "jotai";
import { UpdateViewMode } from "../api/Users";

export type ViewMode = "simple" | "advanced";

const localStorageKey = "viewMode";

const getInitialMode = (): ViewMode => {
  const saved = localStorage.getItem(localStorageKey);
  if (saved === "simple" || saved === "advanced") return saved;
  return "simple";
};

export const ViewModeAtom = atom<ViewMode>(getInitialMode());

ViewModeAtom.onMount = (setAtom) => {
  const saved = localStorage.getItem(localStorageKey);
  if (saved === "simple" || saved === "advanced") {
    setAtom(saved);
  }
};

// This function now saves to both localStorage and the database
export const setViewModeInStorage = async (mode: ViewMode): Promise<void> => {
  localStorage.setItem(localStorageKey, mode);
  
  // Also save to the database
  try {
    await UpdateViewMode(mode);
  } catch (error) {
    console.error("Failed to update view mode in database:", error);
  }
};


